<template>
    <div class="inscription">
        <el-row type="flex" justify="center">
            <el-col class="is-text-align-center logobox">
                <svg-icon icon-class="logo" />
                <h1>DEMANDE D'INSCRIPTION</h1>
                <div v-show="sended">
                    {{ inscriptionForm.name }}
                    {{ inscriptionForm.prenom }},<br />
                    Votre demande a été envoyée, vous allez recevoir un email
                    automatique de confirmation à l'adresse
                    {{ inscriptionForm.email }}.<br />
                    Nous vous contacterons rapidement pour vous tenir informer
                    de la suite de votre demande.<br /><br />
                    <el-button
                        type="success"
                        class="button"
                        @click.native.prevent="$router.push(`/login`)"
                    >
                        retour accueil
                    </el-button>
                </div>
            </el-col>
        </el-row>

        <el-form
            ref="inscriptionForm"
            :model="inscriptionForm"
            :rules="rules"
            class="login-form"
            auto-complete="off"
            label-position="left"
            label-width="180px"
            v-loading="sending"
            v-show="!sended"
        >
            <el-form-item
                prop="name"
                label="Nom*"
                :error="getErrorForField('name', errors)"
            >
                <el-input
                    v-model="inscriptionForm.name"
                    name="name"
                    type="text"
                    auto-complete="off"
                    placeholder="Nom"
                    prefix-icon="el-icon-user"
                />
            </el-form-item>
            <el-form-item
                prop="prenom"
                label="Prénom*"
                :error="getErrorForField('prenom', errors)"
            >
                <el-input
                    v-model="inscriptionForm.prenom"
                    name="prenom"
                    type="text"
                    auto-complete="off"
                    placeholder="Prénom"
                    prefix-icon="el-icon-user"
                />
            </el-form-item>
            <el-form-item
                prop="email"
                label="Email*"
                :error="getErrorForField('email', errors)"
            >
                <el-input
                    v-model="inscriptionForm.email"
                    name="email"
                    type="text"
                    auto-complete="off"
                    placeholder="Email"
                    prefix-icon="el-icon-message"
                />
            </el-form-item>
            <el-form-item prop="message" label="Message">
                <el-input
                    v-model="inscriptionForm.message"
                    name="message"
                    type="textarea"
                    :rows="3"
                    auto-complete="off"
                    placeholder="Message (opt.)"
                />
            </el-form-item>
            <!--
            <el-form-item
                prop="telportable"
                label="Tél. port."
                :error="getErrorForField('telportable', errors)"
            >
                <el-input
                    v-model="inscriptionForm.telportable"
                    name="telportable"
                    type="text"
                    auto-complete="off"
                    placeholder="Tél. port."
                    prefix-icon="el-icon-mobile-phone"
                />
            </el-form-item>
            -->
            <el-form-item
                prop="telfix"
                label="Téléphone*"
                :error="getErrorForField('telfix', errors)"
            >
                <el-input
                    v-model="inscriptionForm.telfix"
                    name="telfix"
                    type="text"
                    auto-complete="off"
                    placeholder="Téléphone"
                    prefix-icon="el-icon-phone"
                />
            </el-form-item>
            <el-form-item
                prop="livraison_adresse_showlabel"
                label="Adresse de livraison*"
                :error="getErrorForField('livraison_adresse_showlabel', errors)"
            >
                <adresseline
                    prop="livraison_adresse_showlabel"
                    column_adresse="livraison_adresse"
                    :noserver="true"
                    :parent="this"
                    :editAdresse="inscriptionForm.livraison_adresse"
                />
                Uniquement France.
            </el-form-item>
            <el-form-item label="Adresse de facturation" prop="adresse">
                <el-switch
                    v-model="commeLivraison"
                    active-color="#38A528"
                    :active-text="'comme livraison'"
                />
                <adresseline
                    v-if="!commeLivraison"
                    prop="facturation_adresse_showlabel"
                    column_adresse="facturation_adresse"
                    :noserver="true"
                    :parent="this"
                    :editAdresse="inscriptionForm.facturation_adresse"
                />
            </el-form-item>
            <div class="controls">
                <el-button
                    class="button"
                    @click.native.prevent="$router.push(`/login`)"
                >
                    Annuler
                </el-button>
                <el-button
                    :disabled="cantsave"
                    type="success"
                    class="button"
                    @click="sendDemande"
                >
                    Envoyer
                </el-button>
            </div>
        </el-form>
        <el-dialog
            title=" "
            :visible.sync="charteVisible"
            class="charte"
        >
            <div v-html="options['allocations_charte']" />
            <div slot="footer" class="dialog-footer">
                <el-button @click="charteVisible = false">Annuler</el-button>
                <el-button type="success" @click="validDemande"
                    >Accepter</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Inscription from "@/api/inscription";
const inscriptionResource = new Inscription();
import Adresseline from "@/components/Adresseline";
import { findoptions } from "@/utils/options";

export default {
    name: "Inscription",
    components: {
        Adresseline
    },
    data() {
        return {
            inscriptionForm: {
                /*
                email: "jose@zz.com",
                name: "v",
                prenom: "j",
                telfix: "0988776655",
                */
                email: "",
                name: "",
                prenom: "",
                message: "",
                telfix: "",
                // telportable: "",
                livraison_adresse: {},
                livraison_adresse_showlabel: "",
                facturation_adresse: {},
                facturation_adresse_showlabel: ""
            },
            rules: {
                name: {},
                // telportable: {},
                telfix: {},
                email: {},
                prenom: {},
                livraison_adresse_showlabel: {}
            },
            charteVisible: false,
            errors: [],
            dialogAdressesVisible: false,
            active_column_adresse: null,
            commeLivraison: true,
            edit_adresse: null,
            sending: false,
            sended: false,
            cantsave: false,
            options: {
                allocations_charte: ""
            }
        };
    },
    watch: {
        commeLivraison(val) {
            if (!val) {
                this.inscriptionForm.facturation_adresse_showlabel = "";
                this.inscriptionForm.facturation_adresse = {};
            }
        }
    },
    created() {
        findoptions(this.options, this);
    },
    methods: {
        callbackoptions(slug, data) {
            this.options[slug] = data;
        },
        editAdresse(column_adresse) {
            //livraison_adresse ou facturation_adresse
            console.log("bb" + column_adresse);
            this.active_column_adresse = column_adresse;
            this.edit_adresse = this.inscriptionForm[column_adresse];
            this.dialogAdressesVisible = true;
        },
        callbackAdresse(activeAdresse, prop, column_adresse) {
            //restart
            if (!activeAdresse) {
                this.inscriptionForm[prop] = "";
                this.inscriptionForm[column_adresse] = {};
                return true;
            }
            console.log("callbackAdresse");
            console.log(activeAdresse);
            this.inscriptionForm[column_adresse] = activeAdresse;
            var housenumber = activeAdresse.housenumber
                ? activeAdresse.housenumber + " "
                : "";
            var complement = activeAdresse.complement
                ? activeAdresse.complement + " "
                : "";
            var showlabel =
                housenumber +
                activeAdresse.street +
                " " +
                complement +
                activeAdresse.postcode +
                " " +
                activeAdresse.city;

            this.inscriptionForm[prop] = showlabel;
        },
        validDemande() {
            this.errors = [];
            this.sending = true;
            inscriptionResource
                .demande(this.inscriptionForm)
                .then(response => {
                    console.log("response");
                    console.log(response.data);
                    this.sending = false;
                    this.charteVisible = false;
                    this.$message({
                        message: "Demande envoyée",
                        type: "success",
                        duration: 5 * 1000
                    });
                    this.sended = true;
                })
                .catch(error => {
                    console.log("error");
                    console.log(error.response);
                    if (error.response && error.response.data) {
                        // this.errors = error.response.data.errors;
                        Object.assign(this.errors, error.response.data.errors);
                    }
                    this.updating = false;
                    this.charteVisible = false;
                    this.$message({
                        message: "Erreur d'inscription",
                        type: "error",
                        duration: 5 * 1000
                    });
                    this.sending = false;
                    this.sended = false;
                });
        },
        sendDemande() {
            this.errors = [];
            this.sending = true;
            inscriptionResource
                // .demande(this.inscriptionForm)
                .testdemande(this.inscriptionForm)
                .then(response => {
                    console.log("response");
                    console.log(response.data);
                    this.sending = false;
                    this.charteVisible = true;
                    /*
                    this.$message({
                        message: "Test envoyé",
                        type: "success",
                        duration: 5 * 1000
                    });
                    */

                    //this.sended = true;
                })
                .catch(error => {
                    console.log("error");
                    console.log(error.response);
                    if (error.response && error.response.data) {
                        // this.errors = error.response.data.errors;
                        Object.assign(this.errors, error.response.data.errors);
                    }
                    this.updating = false;
                    this.$message({
                        message: "Erreur d'inscription",
                        type: "error",
                        duration: 5 * 1000
                    });
                    this.sending = false;
                    this.sended = false;
                });
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        }
    }
};
</script>
